
import { Link } from "react-router-dom";

const NavbarLogo = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Link to="/" onClick={scrollToTop} className="flex items-center">
      <img 
        src="/lovable-uploads/99032d9c-f4f6-4d7e-8e3e-5fd2fdf43cc4.png" 
        alt="Okkio Logo" 
        className="h-10 w-26" 
      />
    </Link>
  );
};

export default NavbarLogo;
